
type valueCallBack<T> = ((data: T) => string)
export function createOptions<T>(data: T[], valueCallBack: valueCallBack<T>, textCallBack: valueCallBack<T>): HTMLOptionElement[] {
    return data.map(e => {
        let option = document.createElement("option");
        option.value = valueCallBack(e);
        option.text = textCallBack(e);
        return option;
    })
}

export function addOptionsToSelect(select: HTMLSelectElement, options: HTMLOptionElement[]) {
    options.forEach(e => select.options.add(e));
}

export function addOptionsToSelectBySelector<T>(selector: string, data: T[], valueCallBack: valueCallBack<T>, textCallBack: valueCallBack<T>) {
    let options = createOptions(data, valueCallBack, textCallBack);
    let select = <HTMLSelectElement>document.querySelector(selector);
    options.forEach(e => select.appendChild(e));
}
export function addDefaultOptionsToSelectBySelector(selector: string, value: string, text: string): void {
    let option = document.createElement("option");
    option.value = value;
    option.text = text;
    option.selected = true;
    let select = <HTMLSelectElement>document.querySelector(selector);
    select.appendChild(option);
}

export function addDefaultOptionsToSelectElement(select: HTMLSelectElement, value: string, text: string): void {
    let option = document.createElement("option");
    option.value = value;
    option.text = text;
    option.selected = true;
    select.appendChild(option);
}